<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-4">
<p class="centerImage"><img alt="images" id="img8" src="images/img8.jpg" style="max-width:100%;"/></p>
<p class="caption"><span class="t24">Law report from</span> <span class="t24"><em class="italic">The Times,</em></span> <span class="t24">1805, re a gentleman’s grudge</span><span class="t24"><em class="italic">.</em></span> <span class="smallcaps">Author’s collection</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_ch14.vue?c9c5ee5c